import { apiRequest } from "../../../shared/lib/api";
import type {
  DiscountCoupon,
  DiscountCouponPayload,
} from "../types/discountCoupon";

const ADMIN_DISCOUNT_COUPONS_PATH = "/api/admin/discount-coupons";

function authHeaders(token: string) {
  return { Authorization: `Bearer ${token}` };
}

export function listDiscountCoupons(token: string) {
  return apiRequest<DiscountCoupon[]>(ADMIN_DISCOUNT_COUPONS_PATH, {
    headers: authHeaders(token),
  });
}

export function createDiscountCoupon(
  token: string,
  payload: DiscountCouponPayload,
) {
  return apiRequest<DiscountCoupon>(ADMIN_DISCOUNT_COUPONS_PATH, {
    method: "POST",
    headers: authHeaders(token),
    body: JSON.stringify(payload),
  });
}

export function updateDiscountCoupon(
  token: string,
  id: number,
  payload: DiscountCouponPayload,
) {
  return apiRequest<DiscountCoupon>(
    `${ADMIN_DISCOUNT_COUPONS_PATH}/${encodeURIComponent(String(id))}`,
    {
      method: "PUT",
      headers: authHeaders(token),
      body: JSON.stringify(payload),
    },
  );
}

export function deleteDiscountCoupon(token: string, id: number) {
  return apiRequest<{ ok: boolean; mode?: "deleted" | "deactivated" }>(
    `${ADMIN_DISCOUNT_COUPONS_PATH}/${encodeURIComponent(String(id))}`,
    {
      method: "DELETE",
      headers: authHeaders(token),
    },
  );
}
